import { queryOptions } from '@tanstack/react-query';
import { fetchUser, fetchUsers, fetchUsersByPlanet } from '../api/users';
import { QUERY_KEYS, STALE_TIMES } from '../../utils/constants';

/**
 * Query options factory for the users list.
 */
export const usersQueryOptions = () =>
  queryOptions({
    queryKey: QUERY_KEYS.users,
    queryFn: fetchUsers,
    staleTime: STALE_TIMES.users,
  });

/**
 * Query options factory for a single user by ID.
 */
export const userQueryOptions = (id: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.user(id),
    queryFn: () => fetchUser(id),
    staleTime: STALE_TIMES.users,
    enabled: !!id,
  });

/**
 * Query options factory for users belonging to a specific planet.
 */
export const planetUsersQueryOptions = (planetId: string) =>
  queryOptions({
    queryKey: QUERY_KEYS.planetUsers(planetId),
    queryFn: () => fetchUsersByPlanet(planetId),
    staleTime: STALE_TIMES.users,
    enabled: !!planetId,
  });
